import { TextField, inputBaseClasses } from "@mui/material";
import { styled } from "@mui/material/styles";
import Search from "../../assets/icons/Search.js";
import "react/jsx-runtime";
const SearchInputWrapper = styled("div")(
  () => `
    position: relative;
    margin: 8px 16px;
  `
);
const SearchInput = styled(TextField)(
  ({ theme }) => `
    && {
      & .${inputBaseClasses.root} {
        font-weight: 700;
        font-family: Lato;
        background: ${theme.palette.common.white};
        border-radius: 8px;
        border-color: ${theme.palette.grey[600]};
        width: 100%;
        margin: 0;
 
        input {
          padding: 8px 0;
          height: auto;
          font: inherit;
          font-size: 14px;
 
          &:hover::before, &:hover::after, &::before, &::after {
            border: none;
          }
        }
      }
    }
  `
);
const SearchIcon = styled(Search)(
  ({ theme }) => `
    position: absoulte;
    z-index: 2;
    top: 9px;
    left: 16px;
    width: 16px;
    height: 16px;
    color: ${theme.palette.grey[700]};
  `
);
export {
  SearchIcon,
  SearchInput,
  SearchInputWrapper
};
